
/* Decide play-vs-skip before the intro markup is parsed, so a skipped intro
   never downloads its artwork (was ~190KB wasted on every return visit). */
(function(){
  var play = true;
  try{
    if (localStorage.getItem('flIntroSeen') === '1') play = false;
    else localStorage.setItem('flIntroSeen','1');
  }catch(e){}
  window.FL_PLAY_INTRO = play;
  if (!play) document.documentElement.classList.add('fl-skip-intro');
})();

;

/* Leaflet (~160KB, third-party) is only needed by the store locator, which sits
   about three screens down. Load it when the reader gets close, not on boot. */
window.flLazyLeaflet = (function(){
  var started = false, done = false, queue = [];
  function ready(){ done = true; queue.forEach(function(f){ try{ f(); }catch(e){} }); queue = []; }
  function start(){
    if (started) return; started = true;
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    css.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    css.crossOrigin = '';
    document.head.appendChild(css);
    var js = document.createElement('script');
    js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    js.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    js.crossOrigin = '';
    js.onload = ready;
    js.onerror = function(){ done = true; queue = []; };
    document.head.appendChild(js);
  }
  return function(cb){
    if (done) { cb(); return; }
    queue.push(cb);
    start();
  };
})();
(function(){
  function arm(){
    /* #map is display:none until the locator is used - observing it could never
       fire. Watch the visible #locations section instead. */
    var target = document.getElementById('locations') || document.getElementById('map');
    if (!target) return;
    if (!('IntersectionObserver' in window)) { window.flLazyLeaflet(function(){ if(window.initMap) initMap(); }); return; }
    /* Trust the measurement, not just the event: late-loading media keeps shifting
       the page, so re-check the real distance before committing to the download. */
    function near(){
      var r = target.getBoundingClientRect();
      return r.top - window.innerHeight < 900;
    }
    var io = new IntersectionObserver(function(entries){
      if (!entries.some(function(e){ return e.isIntersecting; })) return;
      if (!near()) return;                 // layout still settling - wait for a real approach
      io.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.flLazyLeaflet(function(){ if (window.initMap) initMap(); });
    }, { rootMargin: '900px 0px' });
    io.observe(target);
    /* belt and braces: a plain scroll check, in case the observer never fires */
    function onScroll(){
      if (!near()) return;
      io.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.flLazyLeaflet(function(){ if (window.initMap) initMap(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  /* Arm only once layout has SETTLED. Armed at DOMContentLoaded the locator is
     still stacked near the top (images have no height yet), so the observer fires
     immediately and Leaflet loads anyway - which is the bug this was meant to fix. */
  function armWhenSettled(){
    requestAnimationFrame(function(){ requestAnimationFrame(arm); });
  }
  if (document.readyState === 'complete') armWhenSettled();
  else window.addEventListener('load', armWhenSettled);
})();

;

/* intro plays once per visitor, then never again (Julian: only their first landing) */
(function(){
  try{
    if(window.FL_PLAY_INTRO === false){
      document.documentElement.classList.add('fl-skip-intro');
      var kill=function(){ var i=document.getElementById('intro'); if(i){ i.style.display='none'; i.remove(); }
        document.documentElement.style.overflow=''; };
      if(document.readyState!=='loading') kill(); else document.addEventListener('DOMContentLoaded',kill);
    }
  }catch(e){}
})();

;

/* ================= FROST LAB — public site (v9 · cyan accents back + longer pour anchored to beaker mouth) ================= */
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbyTS10gJCNBxOBMW-tmbFP-7brg1uDITp8oMCroH7oLJ-yeHMhCK8FJi1ZMn9kTamrb/exec";
const LAUNCH = new Date('2026-08-11T00:00:00-07:00').getTime();

const DEFAULTS = {
  products: [
    {name:"Strawberry", exp:"001", desc:"A strawberry milk swirl — smooth, creamy, made with all natural flavors.", allergens:"Contains milk", c1:"#ffc0c4",c2:"#ff5a64",c3:"#c9303c", glow:"rgba(255,90,100,.42)", photo:"frostlab-strawberry.png", featured:true, active:true, revealed:true},
    {name:"Grape", exp:"002", desc:"Deep purple grape, moulded like the real bunch — smooth, creamy, made with all natural flavors.", allergens:"Contains milk", c1:"#cfbcf0",c2:"#a97bf0",c3:"#5b2ea8", glow:"rgba(169,123,240,.42)", photo:"frostlab-grape.png", active:true, revealed:true},
    {name:"Honeydew", exp:"003", desc:"Cool, mellow honeydew melon — smooth, creamy, made with all natural flavors.", allergens:"Contains milk", c1:"#dcecb4",c2:"#b8e356",c3:"#6f9422", glow:"rgba(184,227,86,.40)", photo:"frostlab-honeydew.png", active:true, revealed:true},
    {name:"Pineapple", exp:"004", desc:"Bright golden pineapple, crown and all — smooth, creamy, made with all natural flavors.", allergens:"Contains milk", c1:"#f2dfae",c2:"#f0bd52",c3:"#a8761b", glow:"rgba(240,189,82,.42)", photo:"frostlab-pineapple.png", active:true, revealed:true},
    {name:"Experiment 005", exp:"005", classified:true, photo:"experiment-005.png", active:true},
    {name:"Experiment 006", exp:"006", classified:true, photo:"experiment-006.png", active:true}
  ],
  stores: [],
  reviews: [
    {platform:"TikTok", url:"https://www.tiktok.com/@frostlab.usa", handle:"@snacktester", caption:"These 3D fruit shapes are unreal 🍍❄️", thumbnail:"", featured:true, active:true},
    {platform:"Instagram", url:"https://www.instagram.com/frostlab.usa", handle:"@frozentreats", caption:"Rating the most viral frozen treat of the summer", thumbnail:"", featured:false, active:true},
    {platform:"YouTube", url:"https://youtube.com", handle:"@frozentreatreview", caption:"Ranking every Frost Lab flavor", thumbnail:"", featured:false, active:true},
    {platform:"TikTok", url:"https://www.tiktok.com/@frostlab.usa", handle:"@tryitwithme", caption:"The mystery box came in — unboxing the first experiment", thumbnail:"", featured:false, active:true}
  ],
  content: {
    heroLede:"Four flavors out now, two still in the lab — 3D shaped frozen dairy desserts — made to be shared, snapped, and completely devoured.",
    email:"info@frostlab.us",
    address:"17521 Railroad St, Suite H<br>City of Industry, CA 91748",
    instagram:"https://www.instagram.com/frostlab.usa",
    tiktok:"https://www.tiktok.com/@frostlab.usa",
    x:"https://x.com/frostlab_usa",
    youtube:"https://youtube.com/@frostlab.usa",
    banner:"🧪 <b>Experiment 001</b> declassified <b>August 11, 2026</b>",
    faq:[
      {q:"What is a 3D shaped frozen dessert?", a:"A 3D shaped frozen dessert is moulded into the shape of the fruit it is flavoured with, so a strawberry pop looks like a real strawberry. The style went viral on TikTok for the moment the shell is cut open. Frost Lab's version is a frozen dairy dessert — Experiment 001 is a strawberry milk swirl made with all natural flavors. It contains milk."},
      {q:"Where can I buy Frost Lab?", a:"Frost Lab is sold from freezers placed in convenience stores, grocers, specialty shops and snack shops across the United States. Use the store locator on this page to find a freezer near you. If your local shop does not carry it yet, you can ask them to — or they can request wholesale pricing directly."},
      {q:"Is Frost Lab imported?", a:"Yes. Frost Lab is manufactured in China and imported into the United States, then distributed to stores from City of Industry, California. The 3D fruit-shaped frozen dessert category is manufactured predominantly in Asia."},
      {q:"Can my store buy Frost Lab wholesale?", a:"Yes. Frost Lab sells wholesale to convenience stores, grocers, specialty retailers and snack shops, by the case, with flexible case quantities so a store can start small. Retailers do not pay for freezers. If you need one placed and you are in the Los Angeles area, our exclusive distributor Worldwide Snacks Inc handles it at worldwidesnacksinc.com; anywhere else, ask us on the wholesale form. Request pricing on our wholesale page."},
      {q:"Does Frost Lab contain dairy or allergens?", a:"The current lineup is a dairy-based frozen dessert and every flavor contains milk. Some future flavors may contain tree nuts or coconut. Always check the pack label for the most current allergen information."},
      {q:"What flavors does Frost Lab make?", a:"Four flavors are out now: Experiment 001 Strawberry, 002 Grape, 003 Honeydew and 004 Pineapple — each one a 3D shaped frozen dairy dessert made with all natural flavors. Two more experiments are still classified and are announced here and on Instagram and TikTok at @frostlab.usa."}
    ]
  }
};

let DATA = JSON.parse(JSON.stringify(DEFAULTS));
let MAP = null, MARKERS = [];

function jsonp(params){
  return new Promise((resolve,reject)=>{
    if(!SCRIPT_URL){ reject(new Error('no backend')); return; }
    const cb = 'cb_'+Date.now()+'_'+Math.floor(Math.random()*1e6);
    const s = document.createElement('script');
    const timer = setTimeout(()=>{cleanup();reject(new Error('timeout'));},15000);
    function cleanup(){clearTimeout(timer);delete window[cb];s.remove();}
    window[cb]=d=>{cleanup();resolve(d);};
    s.onerror=()=>{cleanup();reject(new Error('network'));};
    params.callback=cb;
    s.src=SCRIPT_URL+'?'+new URLSearchParams(params).toString();
    document.body.appendChild(s);
  });
}
/* A dropped request must not dead-end somebody at the front door. Retry a couple of
   times, carrying ONE reference so the server replays its first answer rather than
   mailing a second code. Only connection-level failures are retried - a real answer,
   even an unhappy one, is final. */
async function jsonpTry(params, tries){
  var n = tries || 3, ref = 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  var last;
  for (var i = 0; i < n; i++){
    try {
      var q = {}; for (var k in params) q[k] = params[k];
      q.ref = ref;
      return await jsonp(q);
    } catch (e) {
      last = e;
      var msg = String((e && e.message) || '');
      if (msg !== 'network' && msg !== 'timeout') throw e;     /* a real error, not a lost reply */
      if (i < n - 1) await new Promise(function(r){ setTimeout(r, 900 * (i + 1)); });
    }
  }
  throw last;
}
function postForm(payload){
  if(!SCRIPT_URL) return Promise.resolve({ok:true, queued:true});
  return fetch(SCRIPT_URL,{method:'POST',mode:'no-cors',
    headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)})
    .then(()=>({ok:true})).catch(()=>({ok:true, queued:true}));
}
function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

async function loadAll(){
  locGateDefault();
  try{
    /* The token proves this browser verified an email (action=locVerify), and it is
       now the ONLY thing that opens the store list. The old shared LOCATOR_KEY was
       deleted from the backend on purpose - it never expired and had been printed into
       the page for signed-in customers, so it had to be treated as leaked. Do not
       reintroduce a static key here. */
    const q = {action:'sitedata'};
    const tk = locTok();
    if(tk) q.tok = tk;
    const r = await jsonpTry(q, 3);
    /* the backend answers `gated` when no valid key was sent - i.e. the reader is
       not a signed-in customer. Say so rather than showing an empty locator. */
    /* Assign, never latch: signing in has to be able to clear this. Only when the
       call actually answered - a network drop keeps whatever we knew before. */
    if(r) LOCATOR_GATED = !!r.gated;
    if(r && r.ok){
      if(Array.isArray(r.products)&&r.products.length){ DATA.products=r.products; window.FL_SERVER_PRODUCTS=true; }
      if(Array.isArray(r.stores)) DATA.stores=r.stores;
      /* the dashboard can take the locator down - only act on an explicit false, so
         an older backend that does not send the flag keeps working as before */
      if(r.locatorOn===false) LOCATOR_DOWN=true;
      if(Array.isArray(r.reviews)&&r.reviews.length) DATA.reviews=r.reviews;
      if(r.content) DATA.content=Object.assign({}, DEFAULTS.content, r.content);
    }
  }catch(e){}
  renderProducts(); renderStores(); renderReviews(); renderContent();
}

/* The deck is server-rendered in sections/frostlab-home.liquid, so this only runs
   when the dashboard sends its own product list (loadAll sets FL_SERVER_PRODUCTS).
   It writes the SAME markup the section does, so the animator below works either way. */
function renderProducts(){
  const g=document.getElementById('flavDeck');
  if(!g || !window.FL_SERVER_PRODUCTS) return;
  const shown=DATA.products.filter(p=>p.active!==false && (p.revealed===true || /strawberry/i.test(p.name||'')));
  const soon=DATA.products.filter(p=>p.active!==false).length - shown.length;
  g.innerHTML=shown.map((p,i)=>{
    const c=esc(p.c2||'#7fe9ff'), gl=esc(p.glow||'rgba(127,233,255,.4)');
    return `<figure class="flav-item" style="--c:${c};--g:${gl}">
      <span class="flav-vis"><img src="${esc(flAsset(p.photo||'frostlab-logo.png'))}"
        alt="Frost Lab ${esc(p.name)} — 3D shaped frozen dessert" width="589" height="820"
        ${i===0?'fetchpriority="high"':'loading="lazy"'} decoding="async"></span>
      <figcaption>
        <span class="flav-exp">Experiment ${esc(p.exp||('00'+(i+1)).slice(-3))}</span>
        <h3 class="flav-name">${esc(p.name)}</h3>
        <p class="flav-desc">${esc(p.desc||'')}</p>
      </figcaption>
    </figure>`;
  }).join('');
  const sn=document.querySelector('.flav-soon');
  if(sn && soon>0) sn.innerHTML='<b>'+soon+'</b> new flavor'+(soon===1?'':'s')+' coming soon';
  else if(sn) sn.hidden=true;
  if(window.flavDeckInit) window.flavDeckInit();
}
function initMap(){
  if(typeof L==='undefined') return;
  /* scrollWheelZoom on: the map is loaded on demand now, so a stray scroll cannot
     hijack the page on the way past it. */
  MAP=L.map('map',{scrollWheelZoom:true}).setView([39.5,-98.35],4);
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',{
    attribution:'© OpenStreetMap © CARTO', subdomains:'abcd', maxZoom:19
  }).addTo(MAP);
  /* The store data arrives long before this map is built (it loads only when the
     reader nears the locator), so the pins drawn at load time went nowhere. Draw
     them now that there is a map to draw them on. */
  try{ if(typeof drawMarkers==='function' && typeof activeStores==='function') drawMarkers(activeStores()); }catch(e){}
  setTimeout(function(){ try{ MAP.invalidateSize(); }catch(e){} }, 120);
}
function activeStores(){
  var _q=document.getElementById('locSearch'), _s=document.getElementById('locState');
  if(!_q||!_s) return [];            /* locator not on the page - visitor is signed out */
  const q=(_q.value||'').toLowerCase().trim();
  const st=_s.value;
  return DATA.stores.filter(s=>s.active!==false).filter(s=>{
    if(st && (s.state||'')!==st) return false;
    if(!q) return true;
    return [s.name,s.address,s.city,s.state,s.zip].join(' ').toLowerCase().includes(q);
  });
}
var LOCATOR_DOWN=false;
var LOCATOR_GATED=false;
/* A signed-out visitor IS gated. Starting at false meant a network flake on first load
   left them with the gate hidden and no way in at all. Called from loadAll rather than
   here, because the storage keys are declared further down this same script block. */
function locGateDefault(){ try{ LOCATOR_GATED = !locTok(); }catch(e){} }
function renderStores(){
  if(LOCATOR_DOWN){
    var sec=document.getElementById('locations');
    if(sec && !sec.querySelector('.loc-down')){
      ['#locSearch','#locState','#map','#storeList','#slist','.loc-tools','.locgrid','#locGate','.slist-who'].forEach(function(q){
        var el=sec.querySelector(q); if(el) el.style.display='none';
      });
      var box=document.createElement('div');
      box.className='loc-down';
      box.innerHTML='<span class="lock">\uD83D\uDEA7</span>'+
        '<h3>The store locator is under construction</h3>'+
        '<p>We are updating where you can find us. It will be back shortly \u2014 '+
        'in the meantime, drop your ZIP in the sign-up above and we will tell you '+
        'the moment Frost Lab lands near you.</p>';
      (sec.querySelector('.wrap')||sec).appendChild(box);
    }
    return;
  }
  if(LOCATOR_GATED){
    /* A stored token the server will not accept (expired, or the signing secret
       rotated) must never become a dead end - drop it and ask for a fresh code.
       LOC_EXPIRED covers the token this page expired on its own, which is already
       out of storage by the time we get here - without it the explanation is lost
       and the customer just meets a bare sign-in card. */
    var _stale = LOC_EXPIRED || !!LOC_TOK_MEM || !!lsGet(LOCTOK_KEY);
    if(_stale) locForget();
    locShowGate(_stale ? 'That sign-in expired — pop your email in and we’ll send a fresh code.' : '', 'note');
    return;
  }
  locHideGate();                      /* signed in: card away, locator back */
  const sel=document.getElementById('locState');
  if(!sel) return;                    /* signed out: nothing to render */
  const cur=sel.value;
  const states=[...new Set(DATA.stores.filter(s=>s.active!==false).map(s=>s.state).filter(Boolean))].sort();
  sel.innerHTML='<option value="">All states</option>'+states.map(s=>`<option ${s===cur?'selected':''}>${esc(s)}</option>`).join('');
  const list=activeStores();
  const g=document.getElementById('sgrid');
  if(!g) return;
  const totalActive = DATA.stores.filter(s=>s.active!==false).length;
  g.innerHTML = list.length ? list.map(s=>{
    const full=[s.address,s.city,s.state,s.zip].filter(Boolean).join(', ');
    const dir='https://maps.google.com/?q='+encodeURIComponent(full||s.name);
    return `<div class="scard">
      <h4>${esc(s.name)}</h4>
      <div class="addr">${esc(full)}</div>
      <div class="meta">${esc(s.hours||'')}${s.skus?' · '+esc(s.skus):''}</div>
      <a class="dir" href="${dir}" target="_blank" rel="noopener">Get directions →</a>
    </div>`;
  }).join('') : (totalActive === 0
    ? '<div class="empty">❄ We’re loading freezers right now — Get in the Lab and we’ll email you the moment we land near you.</div>'
    : '<div class="empty">No stores match — try a different search, or ask your favorite shop to carry us.</div>');
  slistSync(list.length, totalActive);
  drawMarkers(list);
}
function drawMarkers(list){
  if(!MAP) return;
  MARKERS.forEach(m=>MAP.removeLayer(m)); MARKERS=[];
  const pts=[];
  list.forEach(s=>{
    if(typeof s.lat!=='number'||typeof s.lng!=='number') return;
    const icon=L.divIcon({className:'',html:'<div style="width:16px;height:16px;border-radius:50%;background:#7fe9ff;border:2px solid #05070b;box-shadow:0 0 12px #7fe9ff"></div>',iconSize:[16,16]});
    const m=L.marker([s.lat,s.lng],{icon}).addTo(MAP)
      .bindPopup(`<b>${esc(s.name)}</b><br>${esc([s.address,s.city,s.state].filter(Boolean).join(', '))}`);
    MARKERS.push(m); pts.push([s.lat,s.lng]);
  });
  if(pts.length) MAP.fitBounds(pts,{padding:[40,40],maxZoom:11});
}

function platIcon(p){
  const P=(p||'').toLowerCase();
  if(P.includes('insta')) return '📷';
  if(P.includes('you')) return '▶️';
  if(P==='x'||P.includes('twit')) return '𝕏';
  return '🎵';
}
function renderReviews(){
  const g=document.getElementById('rgrid');
  if(!g) return;
  g.innerHTML=DATA.reviews.filter(r=>r.active!==false).map(r=>{
    const thumb = r.thumbnail ? `<img src="${esc(r.thumbnail)}" alt="${esc(r.handle||'review')}">` : '';
    return `<a class="rcard" href="${esc(r.url||'#')}" target="_blank" rel="noopener">
      <div class="rthumb">${thumb}
        <span class="rplat">${platIcon(r.platform)} ${esc(r.platform||'')}</span>
        <span class="play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>
      </div>
      <div class="rmeta"><div class="handle">${esc(r.handle||'')}</div><div class="cap">${esc(r.caption||'')}</div></div>
    </a>`;
  }).join('') || '<div class="empty">Reviews coming soon — be the first to tag us.</div>';
}

const SVG={
  ig:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17" cy="7" r="1.1" fill="currentColor" stroke="none"/></svg>',
  tt:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 3c.3 2.1 1.6 3.7 3.5 4v2.4c-1.3.1-2.6-.3-3.8-1v6.1a5.6 5.6 0 1 1-5.6-5.6c.3 0 .6 0 .9.1v2.5a3.1 3.1 0 1 0 2.2 3V3h2.8z"/></svg>',
  x:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.2 3H21l-6.4 7.3L22 21h-5.9l-4.6-6-5.3 6H3l6.9-7.9L2 3h6l4.2 5.5L18.2 3zm-2.1 16h1.6L8 5H6.3l9.8 14z"/></svg>',
  yt:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 12s0-3.3-.4-4.8a2.5 2.5 0 0 0-1.8-1.8C19.3 5 12 5 12 5s-7.3 0-8.8.4A2.5 2.5 0 0 0 1.4 7.2C1 8.7 1 12 1 12s0 3.3.4 4.8a2.5 2.5 0 0 0 1.8 1.8C4.7 19 12 19 12 19s7.3 0 8.8-.4a2.5 2.5 0 0 0 1.8-1.8C23 15.3 23 12 23 12zM10 15.5v-7l6 3.5-6 3.5z"/></svg>'
};
function renderContent(){
  const c=DATA.content||{};
  if(c.heroLede){var hl=document.getElementById('heroLede'); if(hl) hl.textContent=c.heroLede;}
  if(c.banner){var bn=document.getElementById('banner'); if(bn) bn.innerHTML=c.banner+' — <span class="cd" id="bannerCd">soon</span>';}
  if(c.address) document.getElementById('footAddr').innerHTML=c.address;
  if(c.email){const fe=document.getElementById('footEmail');fe.textContent=c.email;fe.href='mailto:'+c.email;}
  const soc=[['ig',c.instagram,'Instagram'],['tt',c.tiktok,'TikTok'],['x',c.x,'X'],['yt',c.youtube,'YouTube']];
  document.getElementById('social').innerHTML=soc.filter(s=>s[1]).map(([k,url,label])=>
    `<a class="sbtn ${k}" href="${esc(url)}" target="_blank" rel="noopener" aria-label="${label}">${SVG[k]}</a>`).join('');
  const faq=Array.isArray(c.faq)?c.faq:[];
  document.getElementById('faqList').innerHTML=faq.map(f=>
    `<details class="qa"><summary>${esc(f.q)}<span class="plus">+</span></summary><div class="a">${esc(f.a)}</div></details>`).join('');
  try{faqSync();}catch(e){}
}

function tick(){
  /* site launches AFTER the Grand Reveal — countdown stays at zero */
  let d=0;
  const days=Math.floor(d/864e5); d-=days*864e5;
  const hrs=Math.floor(d/36e5); d-=hrs*36e5;
  const min=Math.floor(d/6e4); d-=min*6e4;
  const sec=Math.floor(d/1e3);
  const units=[[days,'Days'],[hrs,'Hours'],[min,'Minutes'],[sec,'Seconds']];
  var cdEl=document.getElementById('countdown');
  if(cdEl) cdEl.innerHTML=units.map(([n,l])=>
    `<div class="unit"><b>${String(n).padStart(2,'0')}</b><span>${l}</span></div>`).join('<span class="sep">:</span>');
  const cd=document.getElementById('bannerCd');
  if(cd) cd.textContent='live now';
}

function showModal(title,body){document.getElementById('modalTitle').textContent=title;
  document.getElementById('modalBody').textContent=body;document.getElementById('modal').classList.add('on');}
function closeModal(){document.getElementById('modal').classList.remove('on');}
function flAsset(f){if(/^(https?:|data:|\/)/.test(f))return f;
  var m=window.FL_ASSET_MAP&&window.FL_ASSET_MAP[f]; if(m) return m;
  return (window.FL_ASSET_BASE||'')+f;}
function fdata(form){const o={};new FormData(form).forEach((v,k)=>o[k]=v);return o;}

/* ---- Get in the Lab popup ---- */
const labPop=document.getElementById('labPop');
function openLab(){
  /* Airtight by construction: labPop.classList.add('on') exists ONLY on the line
     below, and .labpop is display:none until .on - so once flLabDone is set every
     entry point (the 9s timer, the 2-minute timer, the pill, the Sign Up links and
     the big Get-in-the-Lab button) hits this one door and is turned away. */
  if(labDone()){ labDoneNote(); return; }
  hideFab();labPop.classList.remove('closing');labPop.classList.add('on');document.documentElement.classList.add('lablock');}
function labDone(){try{return localStorage.getItem('flLabDone')==='1';}catch(e){return false;}}
var FAB_HTML_LIVE='Join Frost Lab';
var FAB_HTML_DONE='<span class="fabtick" aria-hidden="true">✓</span> You&rsquo;re in the Lab';
/* The pill is never taken away any more - signing up only changes what it says. */
function fabSync(){
  var f=document.getElementById('labFab'); if(!f) return;
  var d=labDone();
  f.classList.toggle('done',d);
  f.innerHTML=d?FAB_HTML_DONE:FAB_HTML_LIVE;
  f.setAttribute('aria-label',d?'You are signed up — what happens next':'Join Frost Lab');
}
function labDoneNote(){
  showModal('You’re in the Lab ❄',
    'You’re signed up and Experiment 001 · Strawberry is on us. We’ll email you the moment Frost Lab lands at a store near you — with the store name, address and directions. Nothing else to do — keep an eye on your inbox.');
}
function showFab(){fabSync();document.getElementById('labFab').classList.add('on');}
function hideFab(){document.getElementById('labFab').classList.remove('on');}
function closeLab(){
  labPop.classList.add('closing');
  setTimeout(()=>{labPop.classList.remove('on');labPop.classList.remove('closing');
    document.documentElement.classList.remove('lablock');showFab();},430);
  try{localStorage.setItem('flLabSeen','1');}catch(e){}}
document.getElementById('labPopX').addEventListener('click',closeLab);
labPop.addEventListener('click',e=>{if(e.target===labPop)closeLab();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&labPop.classList.contains('on'))closeLab();});
document.getElementById('labOpenBtn').addEventListener('click',openLab);
document.querySelectorAll('a[href="#signup"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();openLab();}));
let LABWON=false,LABSPIN=false;
function labWin(){
  if(LABWON)return; LABWON=true; LABSPIN=false;
  try{localStorage.setItem('flLabDone','1');}catch(e){}
  unlockStores();
  fabSync();
  document.getElementById('flWheel').classList.add('won');
  document.querySelector('.labpop-card').classList.add('won');
  document.getElementById('labSub').innerHTML='🍓 <strong>YOU WON!</strong> Experiment 001 · STRAWBERRY is yours <strong>FREE</strong> — you\u2019ll get an email alert the moment it\u2019s at a store near you.';
  const go=document.querySelector('.labpop-go'); go.disabled=false; go.textContent='Awesome ❄';
  document.getElementById('labMsg').textContent='';
}
document.getElementById('labForm').addEventListener('submit',async e=>{
  e.preventDefault();
  if(LABWON){unlockStores();closeLab();labDoneNote();return;}
  if(LABSPIN)return;
  const m=document.getElementById('labMsg');
  const d=fdata(e.target);const email=d.email;const zip=(d.zip||'').trim();
  if(!email||!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){m.className='fmsg err';m.textContent='Enter a valid email.';return;}
  if(!(d.flavor||'').trim()){m.className='fmsg err';m.textContent='Tell the lab a flavor you want 🍓';return;}
  if(zip&&!/^\d{5}$/.test(zip)){m.className='fmsg err';m.textContent='ZIP code should be 5 digits.';return;}
  LABSPIN=true;
  const go=document.querySelector('.labpop-go'); go.disabled=true; go.textContent='Spinning…';
  m.className='fmsg ok';m.textContent='';
  postForm({formType:'signup',email,zip,flavor:(d.flavor||'').trim(),source:'lab-popup'});
  const wheel=document.getElementById('flWheel');
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches){labWin();return;}
  const freeSegs=[0,2,4];
  const seg=freeSegs[Math.floor(Math.random()*freeSegs.length)];
  const center=seg*60+30;
  const jitter=(Math.random()*20)-10;
  const target=5*360+(360-center)+jitter;
  wheel.addEventListener('transitionend',labWin,{once:true});
  setTimeout(labWin,5400);
  requestAnimationFrame(()=>{wheel.style.transform='rotate('+target+'deg)';});
});
/* minimized button + auto-open: first at 9s, then re-pops every two minutes until they sign up */
document.getElementById('labFab').addEventListener('click',openLab);
showFab();
/* 2026-09-28: it used to open itself after 9s and again every 2 minutes until you signed
   up, which is what made it feel like a generic pop-up. Now it waits until the visitor has
   actually reached the flavors, opens once, and never nags again if they closed it. The
   pill, the Get-in-the-Lab button and the Sign Up links still open it on demand. */
(function(){
  var fired=false;
  function seen(){try{return localStorage.getItem('flLabSeen')==='1';}catch(e){return false;}}
  function maybeOpen(){
    if(fired||labDone()||seen()||labPop.classList.contains('on'))return;
    fired=true; openLab();
  }
  /* Trigger on real scrolling, not on an element being visible: on a tall screen the
     flavors heading is already in view at the top of the page, so watching it opened the
     popup without the visitor doing anything. More than one screen of scrolling means
     they are genuinely reading the page. */
  function onScroll(){
    if(fired) return;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if(y > Math.max(700, innerHeight * 1.15)){
      window.removeEventListener('scroll', onScroll);
      setTimeout(maybeOpen, 900);
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
})();
/* mobile search toggle */
(function(){const t=document.getElementById('nsxTgl'),f=document.getElementById('nsx');if(!t||!f)return;
t.addEventListener('click',()=>{f.classList.toggle('open');if(f.classList.contains('open'))f.querySelector('input').focus();});})();

document.getElementById('retailerForm').addEventListener('submit',async e=>{
  e.preventDefault();const m=document.getElementById('retailerMsg');const d=fdata(e.target);
  if(!d.business||!d.contact||!d.email){m.className='fmsg err';m.textContent='Please fill in the required fields.';return;}
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.email)){m.className='fmsg err';m.textContent='Enter a valid email.';return;}
  m.className='fmsg ok';m.textContent='Sending…';
  await postForm(Object.assign({formType:'retailer'},d));
  e.target.reset();m.textContent='';showModal('Request received! 📦',"Thanks — our wholesale team will reach out with pricing and case sizes.");
});

document.getElementById('burger').addEventListener('click',()=>document.getElementById('navLinks').classList.toggle('open'));
(function(){var fl=document.querySelector('#intro .fl-logo');if(fl&&fl.complete&&fl.naturalWidth)fl.classList.add('ld');})();
document.getElementById('navClose').addEventListener('click',()=>document.getElementById('navLinks').classList.remove('open'));
document.addEventListener('click',e=>{const nl=document.getElementById('navLinks');
  if(nl.classList.contains('open')&&!e.target.closest('#navLinks,#burger'))nl.classList.remove('open');});
document.querySelectorAll('#navLinks a').forEach(a=>a.addEventListener('click',()=>document.getElementById('navLinks').classList.remove('open')));
var _ls=document.getElementById('locSearch'); if(_ls) _ls.addEventListener('input',renderStores);
var _lt=document.getElementById('locState'); if(_lt) _lt.addEventListener('change',renderStores);
document.getElementById('modal').addEventListener('click',e=>{if(e.target.id==='modal')closeModal();});

/* initMap is now called by the lazy Leaflet loader when the locator nears view */
window.initMap = initMap;


/* ---- store list: collapsible disclosure -------------------------------------
   Whether there is anything to disclose is decided by the sign-in below, and
   enforced server-side: action=sitedata returns no addresses without a token. */
var SLIST_KEY='flStoreListOpen', LEMAIL_KEY='flLabEmail';
function lsGet(k){try{return localStorage.getItem(k);}catch(e){return null;}}
function lsSet(k,v){try{localStorage.setItem(k,v);}catch(e){}}
function labEmail(){return lsGet(LEMAIL_KEY)||'';}
function labSaveEmail(v){
  if(!v){var i=document.querySelector('#labForm input[name=email]');v=i?i.value:'';}
  v=String(v||'').trim();
  if(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) lsSet(LEMAIL_KEY,v);
}
/* The Get-in-the-Lab signup no longer unlocks anything on its own - it just
   leaves the address behind so the locator sign-in can prefill it. */
function unlockStores(email){labSaveEmail(email);try{renderStores();}catch(e){}}
function slistIsOpen(){return lsGet(SLIST_KEY)==='1';}
function setSlistOpen(on){
  lsSet(SLIST_KEY,on?'1':'0');
  var b=document.getElementById('slistBody'),t=document.getElementById('slistTgl'),a=document.getElementById('slistAct');
  if(b) b.hidden=!on;
  if(t) t.setAttribute('aria-expanded',on?'true':'false');
  if(a) a.textContent=on?'hide list':'show list';
}
function slistSync(shown,total){
  var c=document.getElementById('slistCount');
  if(c&&typeof total==='number')
    c.textContent=(shown===total?String(total):shown+' of '+total)+' store'+(total===1?'':'s');
}

/* ---- locator sign-in: email + 6-digit code ---------------------------------
   Our own gate, on our own page - no third-party login screen. locCode mails a
   code, locVerify trades it for a short-lived token, and that token is what
   sitedata wants before it will part with an address. */
var LOCTOK_KEY='flLocTok', LOCMAIL_KEY='flLocEmail', LOCEXP_KEY='flLocExp';
var LOCPEND_KEY='flLocPend';
var LG_STEP=1, LG_BUSY=false, LG_EMAIL='', LG_TIMER=null, LG_LEFT=0, LG_CODE_PREV='';
/* In-app browsers (Instagram, TikTok) and locked-down Safari refuse localStorage
   outright, and lsSet swallows the failure - so the token was written nowhere, the
   next read found nothing, and a customer who typed the RIGHT code was bounced
   straight back to the sign-in card, forever. Hold it in memory as well: storage is
   the nice-to-have, the variable is what makes this tab work. */
var LOC_TOK_MEM='', LOC_MAIL_MEM='', LOC_EXP_MEM=0;
/* set when we expire a token on this side, so renderStores can still explain why */
var LOC_EXPIRED=false;

function ssGet(k){try{return sessionStorage.getItem(k);}catch(e){return null;}}
function ssSet(k,v){try{sessionStorage.setItem(k,v);}catch(e){}}
function ssDel(k){try{sessionStorage.removeItem(k);}catch(e){}}

/* This flow REQUIRES leaving the browser to open the mail app, and iOS discards
   backgrounded tabs constantly. Remember which address is mid-verification so a
   returning customer is not sent back to step 1 holding a perfectly good code.
   sessionStorage on purpose - it should not outlive the tab. */
function locPendSave(em){ ssSet(LOCPEND_KEY, JSON.stringify({e:em,t:Date.now()})); }
function locPendLoad(){
  try{
    var o=JSON.parse(ssGet(LOCPEND_KEY)||'null');
    if(o && o.e && o.t && (Date.now()-o.t) < 20*60*1000) return String(o.e);
  }catch(e){}
  return '';
}
function locPendClear(){ ssDel(LOCPEND_KEY); LG_EMAIL=''; }

function locForget(){
  LOC_TOK_MEM=''; LOC_MAIL_MEM=''; LOC_EXP_MEM=0;
  [LOCTOK_KEY,LOCMAIL_KEY,LOCEXP_KEY].forEach(function(k){try{localStorage.removeItem(k);}catch(e){}});
}
function locRemember(tok,mail,exp){
  LOC_TOK_MEM=String(tok||''); LOC_MAIL_MEM=String(mail||''); LOC_EXP_MEM=parseInt(exp||0,10)||0;
  lsSet(LOCTOK_KEY,LOC_TOK_MEM); lsSet(LOCMAIL_KEY,LOC_MAIL_MEM); lsSet(LOCEXP_KEY,String(LOC_EXP_MEM));
}
function locTok(){
  var t=LOC_TOK_MEM||lsGet(LOCTOK_KEY);
  if(!t) return '';
  var exp=LOC_EXP_MEM||parseInt(lsGet(LOCEXP_KEY)||'0',10);
  /* expire it on this side too, so a dead token cannot buy a pointless round trip */
  if(exp && (exp*1000)<=Date.now()){ locForget(); LOC_EXPIRED=true; return ''; }
  return t;
}
function locSignedEmail(){return LOC_MAIL_MEM||lsGet(LOCMAIL_KEY)||'';}
function locSignedIn(){return !!locTok();}

/* jsonp rejects with Error('timeout') / Error('network'), and every handler did
   (e&&e.message)||'friendly fallback' - e.message is always truthy, so the fallback
   could never fire and the customer was shown the literal word "timeout". Only a
   message we wrote ourselves is ever allowed on screen. */
function locFail(r, fallback){
  var e=new Error((r&&r.error)||fallback||'');
  e.authored=!!(r&&r.error);
  e.burned=!!(r&&(r.burned||r.locked));
  return e;
}
function locErrText(e, fallback){
  if(e && e.authored && e.message) return e.message;
  var m=(e && e.message) ? String(e.message) : '';
  if(m==='timeout') return 'That took longer than it should — check your signal and try again.';
  if(m==='network') return 'We could not reach the lab — check your connection and try again.';
  return fallback;
}

function locMsg(t,cls){
  var m=document.getElementById('lgMsg'); if(!m) return;
  /* politeness first, then the text - an error should cut in, not wait its turn */
  m.setAttribute('aria-live', cls==='err' ? 'assertive' : 'polite');
  m.textContent=t||'';
  m.className='lg-msg'+((t&&cls)?' '+cls:'');
}
function locSay(t){
  var l=document.getElementById('locLive'); if(l) l.textContent=t||'';
}
function locStep(n){
  LG_STEP=n;
  var a=document.getElementById('lgStep1'), b=document.getElementById('lgStep2');
  if(a) a.hidden=(n!==1);
  if(b) b.hidden=(n!==2);
}
function locBad(id,on){
  var el=document.getElementById(id);
  if(!el) return;
  el.classList[on?'add':'remove']('bad');
  /* the pink border says nothing to a screen reader */
  if(on) el.setAttribute('aria-invalid','true'); else el.removeAttribute('aria-invalid');
}
function locBtn(id,txt,off){
  var b=document.getElementById(id); if(!b) return;
  if(txt!=null) b.textContent=txt;
  b.disabled=!!off;
}
function locWhoSync(){
  var w=document.getElementById('flWho'), t=document.getElementById('flWhoT');
  if(!w) return;
  var on=locSignedIn();
  w.hidden=!on;
  if(on&&t){
    var e=locSignedEmail();
    t.innerHTML=e?('Signed in as <b>'+esc(e)+'</b>'):'You’re signed in';
  }
}
function locShowGate(msg,cls){
  var sec=document.getElementById('locations');
  if(sec) sec.classList.add('gated');
  var g=document.getElementById('locGate');
  if(g) g.hidden=false;
  var em=document.getElementById('lgEmail');
  if(em && !em.value) em.value=locSignedEmail()||labEmail()||'';
  /* A code already went out to this address in this tab - do not make them start over
     just because iOS threw the tab away while they were reading their email. */
  var pend = LG_EMAIL || locPendLoad();
  if(pend && !msg){
    LG_EMAIL=pend;
    if(em && !em.value) em.value=pend;
    var to=document.getElementById('lgSentTo'); if(to) to.textContent=pend;
    locStep(2);
    locMsg('We already sent a code to '+pend+' — pop it in below, or send yourself a fresh one.','note');
  }else{
    locStep(1);
    locMsg(msg||'', cls||'note');
  }
  locWhoSync();
}
function locHideGate(){
  var sec=document.getElementById('locations');
  /* renderStores runs on every keystroke in the search box - stay cheap */
  if(sec && !sec.classList.contains('gated')){ locWhoSync(); return; }
  if(sec) sec.classList.remove('gated');
  var g=document.getElementById('locGate');
  if(g) g.hidden=true;
  locWhoSync();
  /* the map sat behind display:none while signed out, so Leaflet measured it at
     zero - hand it its real size back, then repaint the pins */
  if(typeof MAP!=='undefined' && MAP){
    setTimeout(function(){
      try{ MAP.invalidateSize(); drawMarkers(activeStores()); }catch(e){}
    },60);
  }else if(window.flLazyLeaflet){
    window.flLazyLeaflet(function(){
      try{ if(typeof MAP!=='undefined' && !MAP && window.initMap) initMap(); }catch(e){}
    });
  }
}
function locFmtLeft(s){
  if(s<90) return s+'s';
  var m=Math.floor(s/60), r=s%60;
  return m+':'+(r<10?'0':'')+r;
}
function locResendReady(){
  clearInterval(LG_TIMER); LG_TIMER=null; LG_LEFT=0;
  locBtn('lgResend','Send it again',false);
}
function locCool(secs){
  var b=document.getElementById('lgResend'); if(!b) return;
  clearInterval(LG_TIMER); LG_TIMER=null; LG_LEFT=secs|0;
  function paint(){
    if(LG_LEFT<=0){ clearInterval(LG_TIMER); LG_TIMER=null; b.disabled=false; b.textContent='Send it again'; return; }
    b.disabled=true; b.textContent='Send it again in '+locFmtLeft(LG_LEFT); LG_LEFT--;
  }
  paint(); LG_TIMER=setInterval(paint,1000);
}
function locZip(){
  var z=String(((document.getElementById('lgZip')||{}).value)||'').trim();
  return /^\d{5}$/.test(z) ? z : '';
}
async function locSendCode(){
  if(LG_BUSY) return;
  var em=String(((document.getElementById('lgEmail')||{}).value)||'').trim();
  var zipRaw=String(((document.getElementById('lgZip')||{}).value)||'').trim();
  locBad('lgEmail',false); locBad('lgZip',false);
  if(!/^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/.test(em)){
    locBad('lgEmail',true);
    locMsg('That email does not look right — check it and try again.','err');
    try{document.getElementById('lgEmail').focus();}catch(e){}
    return;
  }
  if(zipRaw && !/^\d{5}$/.test(zipRaw)){
    locBad('lgZip',true);
    locMsg('A ZIP code is 5 digits — or just leave it blank.','err');
    try{document.getElementById('lgZip').focus();}catch(e){}
    return;
  }
  var resending=(LG_STEP===2);
  LG_BUSY=true; LG_EMAIL=em;
  locBtn('lgSend','Sending…',true);
  locBtn('lgResend',null,true);
  locMsg('','');
  try{
    var q={action:'locCode', email:em};
    var z=locZip(); if(z) q.zip=z;
    var r=await jsonpTry(q);
    if(!r || r.ok===false) throw locFail(r,'We could not send that code — try again in a moment.');
    var to=document.getElementById('lgSentTo'); if(to) to.textContent=em;
    LG_EMAIL=em; locPendSave(em);
    var c=document.getElementById('lgCode');
    if(c){ c.value=''; LG_CODE_PREV=''; locBad('lgCode',false); }
    locStep(2);
    /* The backend refuses to re-send to an address that just asked. Saying "sent!"
       when nothing was sent leaves someone waiting on mail that will never arrive -
       tell them plainly, and how long. */
    if(r.sent===false && r.throttled){
      var w=parseInt(r.waitMin,10); if(!(w>0)) w=1;
      locMsg('We already sent a code to '+em+' a moment ago — use that one. '+
             'We can send another in '+w+' minute'+(w===1?'':'s')+'.','note');
      locCool(Math.min(w*60,900));
    }else{
      locMsg('We sent a 6-digit code to '+em+'. It lands in a minute or two — check spam if it hides.','ok');
      locCool(30);
    }
    if(c){ try{c.focus();}catch(e){} }
  }catch(e){
    /* the send failed, so let them try again straight away - and put the label back,
       or the button reads "Send it again in 12s" while being perfectly clickable */
    locResendReady();
    locMsg(locErrText(e,'We could not send that code — try again in a moment.'),'err');
  }finally{
    /* always give the card back - a stuck flag makes every later tap do nothing */
    LG_BUSY=false;
    locBtn('lgSend','Email me a code',false);
  }
}
async function locSubmitCode(){
  if(LG_BUSY) return;
  var c=document.getElementById('lgCode');
  var code=String((c&&c.value)||'').replace(/\D/g,'');
  locBad('lgCode',false);
  if(code.length!==6){
    locBad('lgCode',true);
    locMsg('The code is 6 digits — have another look at the email.','err');
    if(c){ try{c.focus();}catch(e){} }
    return;
  }
  if(!LG_EMAIL) LG_EMAIL=locPendLoad();
  if(!LG_EMAIL){
    locStep(1);
    locMsg('Pop your email in again and we’ll send a fresh code.','note');
    return;
  }
  LG_BUSY=true;
  locBtn('lgVerify','Checking…',true);
  locMsg('','');
  try{
    var q={action:'locVerify', email:LG_EMAIL, code:code};
    var z=locZip(); if(z) q.zip=z;
    var r=await jsonpTry(q);
    if(!r || r.ok===false || !r.tok) throw locFail(r,'That code did not work — check it, or send a new one.');
    /* memory first: in a webview that refuses storage this variable is the session */
    locRemember(r.tok, LG_EMAIL, r.exp||0);
    labSaveEmail(LG_EMAIL);
    locPendClear();
    LOC_EXPIRED=false;
    LOCATOR_GATED=false;
    clearInterval(LG_TIMER); LG_TIMER=null;
    LG_BUSY=false;
    locHideGate();
    locMsg('','');
    /* the card is about to be display:none'd with focus still inside it, which drops
       focus to <body> and tells a screen-reader user precisely nothing */
    locSay('Signed in — the freezer list is open.');
    var _h=document.getElementById('locHead');
    if(_h){ try{ _h.focus({preventScroll:true}); }catch(e3){ try{_h.focus();}catch(e4){} } }
    await loadAll();                    /* fetch again, this time with the token */
  }catch(e){
    var _txt=locErrText(e,'That code did not work — check it, or send a new one.');
    /* the backend burns the code after too many tries - leaving them on step 2 with a
       dead field is a dead end, so hand them back the email box */
    if((e&&e.burned) || /too many/i.test(_txt)){
      locPendClear();
      if(c){ c.value=''; LG_CODE_PREV=''; }
      locResendReady();
      locStep(1);
      locMsg(_txt+' Pop your email in and we’ll send a fresh one.','err');
      var _em=document.getElementById('lgEmail');
      if(_em){ try{_em.focus();}catch(e5){} }
    }else{
      locMsg(_txt,'err');
      locBad('lgCode',true);
      if(c){ try{c.select();}catch(e2){} }
    }
  }finally{
    LG_BUSY=false;
    locBtn('lgVerify','Show me the freezers',false);
  }
}
function locSignOut(){
  locForget();
  /* deliberate sign-out on a shared phone: do not leave the address behind */
  try{localStorage.removeItem(LEMAIL_KEY);}catch(e){}
  var _em=document.getElementById('lgEmail'); if(_em) _em.value='';
  locPendClear();
  LG_BUSY=false; LG_CODE_PREV='';
  LOC_EXPIRED=false;                  /* they chose this - do not call it an expiry */
  clearInterval(LG_TIMER); LG_TIMER=null;
  var c=document.getElementById('lgCode'); if(c) c.value='';
  LOCATOR_GATED=true;
  try{renderStores();}catch(e){}
  locMsg('Signed out — the freezer list is hidden again.','note');
}
(function(){
  var f=document.getElementById('locGateForm'); if(!f) return;
  /* one submit handler for both steps, so Enter works in either field */
  f.addEventListener('submit',function(e){
    e.preventDefault();
    if(LG_STEP===2) locSubmitCode(); else locSendCode();
  });
  var rs=document.getElementById('lgResend');
  if(rs) rs.addEventListener('click',function(){ if(!rs.disabled) locSendCode(); });
  var ed=document.getElementById('lgEdit');
  if(ed) ed.addEventListener('click',function(){
    clearInterval(LG_TIMER); LG_TIMER=null;
    locPendClear();                   /* different address - the old code is no use */
    locStep(1); locMsg('','');
    var em=document.getElementById('lgEmail');
    if(em){ try{em.focus(); em.select();}catch(e){} }
  });
  var em2=document.getElementById('lgEmail');
  if(em2) em2.addEventListener('input',function(){ locBad('lgEmail',false); });
  var zip=document.getElementById('lgZip');
  if(zip) zip.addEventListener('input',function(){
    var v=zip.value.replace(/\D/g,'').slice(0,5);
    if(v!==zip.value) zip.value=v;
    locBad('lgZip',false);
  });
  var code=document.getElementById('lgCode');
  if(code) code.addEventListener('input',function(ev){
    var before=LG_CODE_PREV;
    var v=code.value.replace(/\D/g,'').slice(0,6);
    if(v!==code.value) code.value=v;
    LG_CODE_PREV=v;
    locBad('lgCode',false);
    /* Phones hand the whole code over from the email, so keep the shortcut for a paste
       or an autofill - but firing on the sixth KEYSTROKE submits the form out from
       under someone typing it in, which is hostile with a screen reader. */
    var pasted = (ev && ev.inputType==='insertFromPaste') || (v.length===6 && before.length<5);
    if(v.length===6 && pasted && !LG_BUSY) locSubmitCode();
  });
  var out=document.getElementById('flOut');
  if(out) out.addEventListener('click',locSignOut);
  locWhoSync();
})();
(function(){
  var t=document.getElementById('slistTgl');if(!t)return;
  setSlistOpen(slistIsOpen());
  slistSync();
  t.addEventListener('click',function(){setSlistOpen(!!document.getElementById('slistBody').hidden);});
  function autoOpen(){
    var q=(document.getElementById('locSearch')||{}).value||'';
    var st=(document.getElementById('locState')||{}).value||'';
    if((String(q).trim()||st)&&!slistIsOpen()) setSlistOpen(true);
  }
  ['locSearch','locState'].forEach(function(id){
    var el=document.getElementById(id);if(!el)return;
    el.addEventListener('input',autoOpen);el.addEventListener('change',autoOpen);
  });
})();

/* ---- FAQ: the same collapsible disclosure as the store list -----------------
   Same markup, same classes, same localStorage habit - one collapsing style on
   the page, not two. Default closed; clicking anything aimed at #faq opens it. */
var FAQ_KEY='flFaqOpen';
function setFaqOpen(on){
  lsSet(FAQ_KEY,on?'1':'0');
  var b=document.getElementById('faqBody'),t=document.getElementById('faqTgl'),a=document.getElementById('faqAct');
  if(b) b.hidden=!on;
  if(t) t.setAttribute('aria-expanded',on?'true':'false');
  if(a) a.textContent=on?'hide questions':'show questions';
}
function faqSync(){
  var c=document.getElementById('faqCount');if(!c)return;
  var n=document.querySelectorAll('#faqList .qa').length;
  c.textContent=n?(n+' question'+(n===1?'':'s')):'Questions';
}
(function(){
  var t=document.getElementById('faqTgl');if(!t)return;
  setFaqOpen(lsGet(FAQ_KEY)==='1');
  faqSync();
  t.addEventListener('click',function(){setFaqOpen(!!document.getElementById('faqBody').hidden);});
  /* landing on the FAQ with it shut would read as an empty section */
  function faqIntent(){setFaqOpen(true);}
  document.querySelectorAll('a[href="#faq"]').forEach(function(a){a.addEventListener('click',faqIntent);});
  if(location.hash==='#faq') faqIntent();
})();

/* ---- "What is a 3D shaped frozen dessert?" explainer ------------------------
   Same disclosure as the FAQ and the store list - one collapsing style on the
   page, not three. Only the detail and the fact cards collapse; the opening
   paragraph is always visible, so the section still answers its own heading. */
var WHAT_KEY='flWhatOpen';
function setWhatOpen(on){
  lsSet(WHAT_KEY,on?'1':'0');
  var b=document.getElementById('whatBody'),t=document.getElementById('whatTgl'),a=document.getElementById('whatAct');
  if(b) b.hidden=!on;
  if(t) t.setAttribute('aria-expanded',on?'true':'false');
  if(a) a.textContent=on?'show less':'read more';
}
(function(){
  var t=document.getElementById('whatTgl');if(!t)return;
  setWhatOpen(lsGet(WHAT_KEY)==='1');
  t.addEventListener('click',function(){setWhatOpen(!!document.getElementById('whatBody').hidden);});
  /* arriving on #what with it shut would read as a half-empty section */
  function whatIntent(){setWhatOpen(true);}
  document.querySelectorAll('a[href="#what"]').forEach(function(a){a.addEventListener('click',whatIntent);});
  if(location.hash==='#what') whatIntent();
})();
tick(); setInterval(tick,1000);
loadAll();

;

(function(){
  var intro=document.getElementById('intro'); if(!intro) return;
  var done=false, timer;
  function finish(){
    if(done)return; done=true; clearTimeout(timer);
    intro.classList.add('gone');
    setTimeout(function(){intro.remove();},460);
  }
  var skip=document.getElementById('flSkip');
  if(skip)skip.addEventListener('click',finish);
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){finish();return;}
  var shards=intro.querySelector('.fl-ice-shards');
  if(shards){
    for(var i=0;i<20;i++){
      var shard=document.createElement('i'), angle=i*Math.PI*2/20;
      shard.style.setProperty('--sx',(45+Math.cos(angle)*30)+'%');
      shard.style.setProperty('--sy',(45+Math.sin(angle)*30)+'%');
      shard.style.setProperty('--sz',(12+i%4*7)+'px');
      shard.style.setProperty('--dx',(Math.cos(angle)*(130+i%3*45))+'px');
      shard.style.setProperty('--dy',(Math.sin(angle)*(130+i%3*45))+'px');
      shard.style.setProperty('--rot',(i%2?150:-130)+'deg');
      shards.appendChild(shard);
    }
  }
  timer=setTimeout(finish,3100);
})();


/* giveaway reels: play in view, tap for sound */
(function(){
  var vids=[].slice.call(document.querySelectorAll('.gvid'));
  if(!vids.length) return;
  /* The three reel posters are ~100KB and sit well below the fold, but a poster
     attribute downloads with the page no matter what preload says. They are held in
     data-poster and attached just before the reel scrolls into view. The load
     fallback means a poster still appears even if the observer never runs. */
  function poster(v){ if(v.dataset.poster){ v.poster=v.dataset.poster; delete v.dataset.poster; } }
  var pio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ poster(e.target); pio.unobserve(e.target); } });
    },{rootMargin:'600px'}) : null;
  if(pio) vids.forEach(function(v){ pio.observe(v); });
  window.addEventListener('load', function(){ setTimeout(function(){ vids.forEach(poster); }, 2500); }, {once:true});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v=e.target;
        if(e.intersectionRatio>=0.25){ v.play().catch(function(){}); }
        else { v.pause(); }
      });
    },{threshold:[0,.25]});
    vids.forEach(function(v){ io.observe(v); });
  } else {
    vids.forEach(function(v){ v.play().catch(function(){}); });
  }
  vids.forEach(function(v){
    v.addEventListener('click',function(){
      v.muted=!v.muted;
      if(!v.muted) v.play().catch(function(){});
      var hint=v.parentNode.querySelector('.mutehint');
      if(hint) hint.textContent=v.muted?'\uD83D\uDD07 Tap for sound':'\uD83D\uDD0A Tap to mute';
    });
  });
})();

/* reels carousel: auto-advance on mobile */
(function(){
  var track=document.querySelector('.reels'); if(!track) return;
  var hold=0;
  function pauseAuto(){ hold=Date.now()+9000; }
  ['touchstart','pointerdown','wheel'].forEach(function(ev){ track.addEventListener(ev,pauseAuto,{passive:true}); });
  setInterval(function(){
    if(document.hidden) return;
    if(track.scrollWidth<=track.clientWidth+8) return;   /* desktop grid: nothing to scroll */
    if(Date.now()<hold) return;
    var r=track.getBoundingClientRect();
    if(r.bottom<0||r.top>innerHeight) return;            /* off-screen: skip */
    var step=track.querySelector('.reel').getBoundingClientRect().width+14;
    var atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-24;
    track.scrollTo({left:atEnd?0:track.scrollLeft+step,behavior:'smooth'});
  },4000);
})();

/* ---- universal double-submit guard (a real distributor lead came in twice) ---- */
(function(){
  document.addEventListener('submit', function(e){
    var f = e.target; if(!f || f.tagName !== 'FORM') return;
    var btn = f.querySelector('button[type="submit"], .submit, button:not([type="button"])');
    if(f.dataset.flBusy === '1'){ e.preventDefault(); e.stopImmediatePropagation(); return; }
    f.dataset.flBusy = '1';
    if(btn){ btn.disabled = true; var t = btn.textContent; btn.dataset.flTxt = t; btn.textContent = 'Sending\u2026'; }
    if(btn){ btn.dataset.flSent = 'Sending\u2026'; }
    setTimeout(function(){
      f.dataset.flBusy = '';
      if(!btn) return;
      btn.disabled = false;
      /* Only put the old label back if the handler has not claimed the button. The spin
         wheel finishes at ~5.4s and writes its own win label; restoring "Spin to win"
         over it would invite somebody to re-enter a draw they have already won. */
      if(btn.dataset.flTxt && btn.textContent === btn.dataset.flSent){ btn.textContent = btn.dataset.flTxt; }
    }, 6000);
  }, true);
  /* same guard for button-driven (non-form) senders */
  ['join','submit'].forEach(function(id){
    var b = document.getElementById(id); if(!b || b.form) return;
    b.addEventListener('click', function(){
      if(b.dataset.flBusy === '1') return;
      b.dataset.flBusy = '1'; b.disabled = true;
      setTimeout(function(){ b.dataset.flBusy=''; b.disabled=false; }, 6000);
    });
  });
})();


/* ---- Flavor deck: the lineup as a scroll-driven 3D showcase ---------------
   The <figure>s already exist in the HTML (sections/frostlab-home.liquid, or
   renderProducts when the dashboard supplies its own list). This adds motion to
   those nodes and nothing else - it never writes copy, so the animation and the
   text can never fall out of step.

   It deliberately stays OFF, leaving the plain grid the CSS already draws, when
   the visitor asked for reduced motion or the screen is too short for a sticky
   stage to be anything but a trap. */
(function(){
  var track=document.getElementById('flavTrack');
  var deck=document.getElementById('flavDeck');
  var dots=document.getElementById('flavDots');
  if(!track||!deck) return;
  var sec=track.parentNode && track.parentNode.classList.contains('flav') ? track.parentNode : track.closest('.flav');
  if(!sec) return;
  var items=[], live=false, cur=-1, ticking=false;
  var mqm=window.matchMedia('(prefers-reduced-motion: reduce)');

  function mobile(){ return window.innerWidth<=900 && items.length>1; }
  function want(){ return !mobile() && !mqm.matches && window.innerHeight>=540 && items.length>1; }
  function syncSwipe(){
    if(!mobile())return;
    var r=deck.getBoundingClientRect(), center=r.left+r.width/2, nearest=0, distance=Infinity;
    items.forEach(function(item,i){var b=item.getBoundingClientRect(),d=Math.abs(b.left+b.width/2-center);if(d<distance){distance=d;nearest=i;}});
    if(nearest!==cur){cur=nearest;syncDots();}
  }
  function setMode(){
    setLive(want());
    sec.classList.toggle('flav--swipe',mobile());
    if(mobile()){ if(dots)dots.hidden=false; syncSwipe(); }
  }

  function collect(){
    items=[].slice.call(deck.querySelectorAll('.flav-item'));
    track.style.setProperty('--n', items.length);
  }

  /* The header is sticky and overlaps the top of the stage - measure it rather
     than hard-coding, because it is a different height per breakpoint. */
  function syncHead(){
    var h=document.querySelector('header.nav');
    var hh=h?Math.round(h.getBoundingClientRect().height):0;
    sec.style.setProperty('--headh', (hh>0?hh+10:72)+'px');
  }

  function nameOf(it,i){
    var n=it.querySelector('.flav-name');
    return (n&&n.textContent.trim())||('Flavor '+(i+1));
  }

  function buildDots(){
    if(!dots) return;
    dots.innerHTML=items.map(function(it,i){
      var c=it.style.getPropertyValue('--c')||'#7fe9ff';
      var g=it.style.getPropertyValue('--g')||'rgba(127,233,255,.6)';
      return '<button class="flav-dot" type="button" role="tab" data-i="'+i+'" tabindex="-1"'+
             ' style="--dc:'+c+';--dg:'+g+'" aria-selected="false" aria-label="Show '+
             nameOf(it,i).replace(/"/g,'&quot;')+'"></button>';
    }).join('');
  }

  function syncDots(){
    if(!dots) return;
    var bs=dots.querySelectorAll('.flav-dot');
    for(var i=0;i<bs.length;i++){
      var on=(i===cur);
      bs[i].setAttribute('aria-selected',on?'true':'false');
      bs[i].tabIndex=on?0:-1;
    }
  }

  /* One flavour per whole number; the fraction between two is the transition. */
  /* Visible art width = deck height x the pack's 589:820 ratio (object-fit:contain
     letterboxes it inside a full-width box), so neighbours sit a fixed fraction of
     the ARTWORK apart at every screen size. */
  function artStep(){
    return Math.max(90, deck.getBoundingClientRect().height*(589/820)*0.82);
  }

  function paint(pos){
    var last=items.length-1, step=artStep();
    var a=Math.max(0,Math.min(last,pos));
    var near=Math.round(a);
    for(var i=0;i<items.length;i++){
      var it=items[i], d=i-a, ad=Math.abs(d);
      if(ad>2.25){ it.style.visibility='hidden'; continue; }
      it.style.visibility='visible';
      it.style.zIndex=String(100-Math.round(ad*12));
      var vis=it.querySelector('.flav-vis');
      if(vis){
        vis.style.transform='translateX('+(d*step).toFixed(1)+'px) translateZ('+(-ad*230).toFixed(0)+'px) '+
                            'rotateY('+(d*-40).toFixed(2)+'deg) scale('+(1-Math.min(ad,2)*0.18).toFixed(3)+')';
        vis.style.opacity=Math.max(0,1-ad*0.5).toFixed(3);
      }
      var cap=it.querySelector('figcaption');
      if(cap){
        /* Exactly ONE caption at a time - whichever flavour is nearest - handed
           over at the midpoint and softened by a CSS transition. Fading them by
           distance instead left a dead spot between two flavours where BOTH had
           reached zero and the deck had no name under it at all. */
        var on=(i===near);
        cap.style.opacity=on?'1':'0';
        cap.style.transform=on?'translateY(0)':'translateY(10px)';
      }
    }
    if(near!==cur){ cur=near; syncDots(); }
  }

  function onScroll(){
    if(!live||ticking) return;
    ticking=true;
    requestAnimationFrame(function(){
      ticking=false;
      if(!live) return;
      var span=track.offsetHeight-window.innerHeight;
      var p=span>0 ? (-track.getBoundingClientRect().top)/span : 0;
      paint(Math.max(0,Math.min(1,p))*(items.length-1));
    });
  }

  function goTo(i){
    if(mobile()){
      var item=items[Math.max(0,Math.min(items.length-1,i))]; if(!item)return;
      var r=deck.getBoundingClientRect(), b=item.getBoundingClientRect();
      deck.scrollTo({left:deck.scrollLeft+b.left+b.width/2-r.left-r.width/2,behavior:mqm.matches?'auto':'smooth'});
      return;
    }
    var span=track.offsetHeight-window.innerHeight;
    if(span<=0||items.length<2) return;
    var top=track.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop||0);
    var y=Math.round(top+span*(i/(items.length-1)));
    try{ window.scrollTo({top:y,behavior:'smooth'}); }catch(e){ window.scrollTo(0,y); }
  }

  function clear(){
    items.forEach(function(it){
      it.style.visibility=''; it.style.zIndex='';
      var v=it.querySelector('.flav-vis'); if(v){ v.style.transform=''; v.style.opacity=''; }
      var c=it.querySelector('figcaption'); if(c){ c.style.opacity=''; c.style.transform=''; }
    });
    cur=-1;
  }

  function setLive(on){
    if(on===live) return;
    live=on;
    sec.classList.toggle('flav--live',on);
    if(dots) dots.hidden=!on;   /* in the grid every flavour is already on screen */
    if(on){ cur=-1; onScroll(); } else { clear(); }
  }

  function init(){
    collect();
    syncHead();
    if(items.length<2){ if(dots) dots.hidden=true; setLive(false); return; }
    buildDots();
    setMode();
    if(live) onScroll();
  }
  window.flavDeckInit=init;

  init();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){ syncHead(); setMode(); onScroll(); });
  deck.addEventListener('scroll',syncSwipe,{passive:true});
  // Touch uses the browser's native pan; mouse and pen can also drag the artwork.
  var drag=null;
  deck.addEventListener('pointerdown',function(e){
    if(!mobile()||e.pointerType==='touch'||e.button!==0)return;
    drag={id:e.pointerId,x:e.clientX,left:deck.scrollLeft};
    deck.setPointerCapture(e.pointerId);deck.classList.add('is-dragging');e.preventDefault();
  });
  deck.addEventListener('pointermove',function(e){
    if(!drag||e.pointerId!==drag.id)return;
    deck.scrollLeft=drag.left+drag.x-e.clientX;
  });
  function endDrag(e){
    if(!drag||e.pointerId!==drag.id)return;
    drag=null;deck.classList.remove('is-dragging');syncSwipe();goTo(cur);
  }
  deck.addEventListener('pointerup',endDrag);
  deck.addEventListener('pointercancel',endDrag);
  deck.addEventListener('lostpointercapture',endDrag);
  if(mqm.addEventListener) mqm.addEventListener('change',function(){ setMode(); });
  if(dots){
    dots.addEventListener('click',function(e){
      var b=e.target.closest && e.target.closest('.flav-dot');
      if(b) goTo(parseInt(b.getAttribute('data-i'),10)||0);
    });
    dots.addEventListener('keydown',function(e){
      if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft') return;
      e.preventDefault();
      var n=items.length, i=Math.min(n-1,Math.max(0,cur+(e.key==='ArrowRight'?1:-1)));
      goTo(i);
      var b=dots.querySelectorAll('.flav-dot')[i]; if(b) b.focus();
    });
  }
})();
